import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import SubscriptionInformationContent
from '../../../../../sections/SubscriptionInformationSection/SubscriptionInformationContent';
import {Button} from '../../../../../UI/Button/Button';
import {hideOverlay} from '../../../../actions/overlay-actions';
import Translation from '../../../../lang/Translation';
import Spacing from '../../../../style-helper/Spacing';
import CheckoutOverlay from '../../CheckoutOverlay';

const useStyles = createUseStyles({
  contentWrapper: {
    padding: [Spacing.triple, Spacing.double],
  },
  subscriptionOverlayExitButtonWrap: {
    margin: Spacing.double,
  },
});

export function SubscriptionInformationOverlay(props) {
  const classes = useStyles();
  
  return (
    <CheckoutOverlay
      popup
      stickyScaleToContentMobile
      ordersummary
      nopadding
      minheight
      title="checkout.subscription.information.section.heading.text"
      {...props}
      data-test="SubscriptionInformationOverlay"
    >
      <div className={classes.contentWrapper}>
        <SubscriptionInformationContent isModal />
      </div>
  
      <div className={classes.subscriptionOverlayExitButtonWrap}>
        <Button
          primary
          fullWidth
          id="subscriptionOverlayCloseButton"
          onClick={props.hideOverlay}
        >
          <Translation>checkout.subscription.mobile.modal.close.btn.text</Translation>
        </Button>
      </div>
    </CheckoutOverlay>
  );
}

SubscriptionInformationOverlay.propTypes = {
  hideOverlay: PropTypes.func.isRequired,
};

export default connect(null, {hideOverlay})(SubscriptionInformationOverlay);
